RivalIQ.module('apps', function (apps, App, Backbone, Marionette, $, _) {

    'use strict';

    const app = apps.Insights = window.createMarionetteApp();
    app.name = 'Insights';

});
